export class EditApi {
    constructor(url) {
        this.url = url;
    }
    async getLatestCommitForBranch(options) {
        const url = `${this.url}branch/${options.branchId}`;
        let headers = undefined;
        if (typeof options.accessToken !== "undefined") {
            headers = {
                Authorization: "Bearer " + options.accessToken,
            };
        }
        const response = await fetch(url, {
            headers: headers,
            signal: options?.signal
        });
        if (!response.ok) {
            throw Error("could not get branch latest commit id");
        }
        const json = await response.json();
        return json.commit.id;
    }
    async getLatestSnapshotCommits(options) {
        const url = `${this.url}snapshot/commit/latest`;
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + options.accessToken,
            },
        });
        const json = await response.json();
        return json.commits;
    }
    async createBranch(options) {
        const url = `${this.url}branch`;
        const body = JSON.stringify({
            SnapshotCommitId: options.snapshotCommitId,
            BranchCommitId: options.branchCommitId,
            BranchId: options.branchId,
            ExtentPolygon: options.extentPolygon
        });
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        const json = await response.json();
        return json;
    }
    async copyBranch(options) {
        const url = `${this.url}branch`;
        const body = JSON.stringify({
            branchId: options.branchId
        });
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        const json = await response.json();
        return json;
    }
    async getCommitsInfo(options) {
        const url = `${this.url}branch/${options.branchId}/commits`;
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + options.accessToken,
            },
        });
        if (!response.ok) {
            throw Error("could not get branch history");
        }
        return await response.json();
    }
}
